export default "__VITE_ASSET__DaxDLwWa__"